import { render, staticRenderFns } from "./DefaultModalBody.vue?vue&type=template&id=33ada8e7&"
import script from "./DefaultModalBody.vue?vue&type=script&lang=js&"
export * from "./DefaultModalBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports